import { render, staticRenderFns } from "./EcMineModule.vue?vue&type=template&id=61431080&scoped=true"
import script from "./EcMineModule.vue?vue&type=script&lang=js"
export * from "./EcMineModule.vue?vue&type=script&lang=js"
import style0 from "./EcMineModule.vue?vue&type=style&index=0&id=61431080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61431080",
  null
  
)

export default component.exports